<div class="login-container">
	<div class="tabs">
		<button class="tab-active" (click)="abrirLogin()">Entrar</button>
		<button (click)="abrirRegistro()">Cadastre-se</button>
		<div class="line" #line></div>
	</div>
	<div class="loginBody">
		<div class="login" #login>
			<form action="POST">
				<div class="uc usuario">
					<label for="E-mail"><fa-icon [icon]="faUserAlt"></fa-icon> E-mail</label>
					<input type="text" name="E-mail" placeholder="E-mail" autocomplete="off" [(ngModel)]="emailL" required>
				</div>	
				<div class="uc contrasena">
					<label for="Contraseña"><fa-icon [icon]="faLock"></fa-icon> Senha</label>
					<input type="password" name="Contraseña" id="" placeholder="Senha" [(ngModel)]="passwordL" required>
				</div>
				<button type="sumbit" (click)="getUser()">Entrar</button>
			</form>
		</div>
		<div class="registro" #registro>
			<form action="">
				<div class="uc usuario">
					<input type="text" name="usuario" placeholder="Nome e sobrenome" autocomplete="off" [(ngModel)]="nombre">
				</div>
				<div class="uc email">
					<input type="email" name="email" placeholder="e-mail" autocomplete="off" 
					[(ngModel)]="email">
				</div>
				<div class="uc usuario">
					<input type="text" name="dni" placeholder="ID" autocomplete="off" [(ngModel)]="dni">
				</div>
				<div class="uc password">
					<input type="password" name="password" placeholder="Senha" [(ngModel)]="password">
				</div>
				<div class="uc password2">
					<input type="password" name="password" placeholder="Confirmar senha">
				</div>
				<button type="button" (click)="createUser()">Cadastrar</button>
			</form>
		</div>
	</div>
</div>
	<div class="returnHome">
		<a [routerLink]="['../home']">Voltar para Home</a>
</div>

<div class="incorrecto-container" #incorrecto>
	<div class="incorrecto">
	<div class="datos">
		<h1>Dados incorretos</h1>
		<p>Reinsira seus dados</p>
	</div>
	<div class="equis">
		<fa-icon [icon]="faTimes"></fa-icon>
	</div>
	<button (click)="volverLogin()">Fechar</button>
	</div>
</div>
